module.exports = __webpack_public_path__ + "static/media/tshirt.9de997b0.svg";